// extracted by mini-css-extract-plugin
module.exports = {"iframe":"LinkPreview_iframe__ZvtPH","container":"LinkPreview_container__IwDnj","loading":"LinkPreview_loading__xmplx"};